import { render, staticRenderFns } from "./ScrollToTop.vue?vue&type=template&id=51c182a2&scoped=true&"
import script from "./ScrollToTop.component.ts?vue&type=script&lang=ts&"
export * from "./ScrollToTop.component.ts?vue&type=script&lang=ts&"
import style0 from "./ScrollToTop.vue?vue&type=style&index=0&id=51c182a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c182a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\e4initra\\e4i-nitra\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c182a2')) {
      api.createRecord('51c182a2', component.options)
    } else {
      api.reload('51c182a2', component.options)
    }
    module.hot.accept("./ScrollToTop.vue?vue&type=template&id=51c182a2&scoped=true&", function () {
      api.rerender('51c182a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/shared/components/scroll-to-top/ScrollToTop.vue"
export default component.exports